import React from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import { LOGO_URL } from '../mock';

const Footer = () => (
  <footer className="bg-[#0f0c2e] text-slate-300 mt-20">
    <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
      <div>
        <div className="bg-white rounded-lg p-3 inline-block mb-4">
          <img src={LOGO_URL} alt="Bezwaarmeesters logo" className="h-10 w-auto" />
        </div>
        <p className="text-sm text-slate-400 leading-relaxed">Gratis bezwaar maken tegen verkeers- en parkeerboetes. No cure, no pay.</p>
      </div>
      <div>
        <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Diensten</h4>
        <ul className="space-y-2 text-sm">
          <li><Link to="/indienen" className="hover:text-white">Bezwaar indienen</Link></li>
          <li><Link to="/werkwijze" className="hover:text-white">Werkwijze</Link></li>
          <li><Link to="/faq" className="hover:text-white">FAQ</Link></li>
          <li><Link to="/blog" className="hover:text-white">Blog</Link></li>
          <li><Link to="/login" className="hover:text-white opacity-60">Admin login</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Juridisch</h4>
        <ul className="space-y-2 text-sm">
          <li><Link to="/algemene-voorwaarden" className="hover:text-white">Algemene voorwaarden</Link></li>
          <li><Link to="/privacybeleid" className="hover:text-white">Privacybeleid</Link></li>
          <li><Link to="/machtigingsformulier" className="hover:text-white">Machtigingsformulier</Link></li>
          <li><Link to="/over-ons" className="hover:text-white">Over ons</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Contact</h4>
        <ul className="space-y-3 text-sm">
          <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-[#f26b1f]" /> <a href="mailto:info@bezwaarmeesters.nl" className="hover:text-white">info@bezwaarmeesters.nl</a></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-slate-500">
        <div>© {new Date().getFullYear()} Bezwaarmeesters.nl - alle rechten voorbehouden.</div>
        <div>KvK 88123456 • BTW NL864123456B01</div>
      </div>
    </div>
  </footer>
);

export default Footer;
